import React, { useEffect, useState } from 'react';
import YouTube from 'react-youtube';
import './index.scss';

export const youtube_parser = (url = false) => {
	if (!url) {
		return false;
	}
    if(url.toLowerCase().indexOf('youtu') < 0) {
        return false;
    }
	var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\/)|(\?v=|\&v=))([^#\&\?]*).*/;
	var match = url.match(regExp);
	if (match && match[8].length === 11) {
		return match[8];
	}
	return false;
};

export default function VideoPreview({videoUrl}) {
    const [youtubeId, setYoutubeId] = useState(false);

    useEffect(() => {
        setYoutubeId(youtube_parser(videoUrl));
    }, [videoUrl]);
    

    return <div className="videoPreview">
        {youtubeId && <YouTube videoId={youtubeId} opts={{height: '336', width: '602'}} />}
        {videoUrl && !youtubeId && <div className="videoPreview-video"><video src={videoUrl} controls></video></div>}
    </div>;
};